/**
 * Shared visual shell for public legal pages (Privacy, Terms).
 */
import React from "react";
import { Link } from "react-router-dom";

const LegalPageShell = ({ title, testid, children }) => (
  <div data-testid={testid} className="min-h-screen bg-[#FAFAF8] text-[#172033]">
    <header className="max-w-2xl mx-auto px-5 pt-8 pb-4">
      <Link
        to="/sign-in"
        data-testid={`${testid}-back`}
        className="inline-flex items-center gap-1.5 mb-5 text-[14px] font-semibold text-[#4A5D4E] hover:opacity-75 transition-opacity"
        aria-label="Back to sign in"
      >
        <span aria-hidden="true">←</span>
        <span>Back</span>
      </Link>
      <div>
        <Link
          to="/sign-in"
          data-testid={`${testid}-brand`}
          className="inline-flex items-center gap-2.5 text-[#172033] hover:opacity-80 transition-opacity"
        >
          <img src="/icons/icon-192-v2.png" alt="" className="h-9 w-9 rounded-[10px]" />
          <span className="text-[16px] font-extrabold tracking-tight">FrontRow Parents</span>
        </Link>
      </div>
      <h1 className="mt-6 text-[28px] font-extrabold tracking-tight">{title}</h1>
    </header>
    <main className="max-w-2xl mx-auto px-5 pb-16" data-testid={`${testid}-content`}>
      {children}
    </main>
    <footer data-testid={`${testid}-footer`} className="max-w-2xl mx-auto px-5 pb-10 border-t border-[#E6E8EB] pt-6">
      <nav className="flex flex-wrap gap-x-4 gap-y-2 text-[13px] text-[#7A7D7B]">
        <Link to="/privacy" data-testid={`${testid}-footer-privacy`} className="hover:text-[#4A5D4E]">Privacy Policy</Link>
        <Link to="/terms" data-testid={`${testid}-footer-terms`} className="hover:text-[#4A5D4E]">Terms of Service</Link>
        <Link to="/sign-in" data-testid={`${testid}-footer-signin`} className="hover:text-[#4A5D4E]">Sign in</Link>
      </nav>
      <p className="mt-3 text-[12px] text-[#9AA09C]">© 2026 FrontRow Parents</p>
    </footer>
  </div>
);

export default LegalPageShell;
